import { FaIcon } from '@ifixit/ui/components/icon';
import { getIndexes, getSearchClient, PUBLIC_KEY, isProUser } from 'Guide/searchClient';
import { InstantSearch } from '@ifixit/ui/components/instant-search';
import deviceNavigator from 'Shared/device_navigator';
import { trackAnalyticsCustomEvent } from '@ifixit/analytics';
import { useTranslations } from '@ifixit/i18n/hooks';

// Add type declaration for window.deviceNavigator
declare global {
   interface Window {
      deviceNavigator?: () => void;
   }
}

export default function InstantSearchHero(props: { prompt: string }) {
   const searchClient = getSearchClient();
   const indices = getIndexes();
   const t = useTranslations('HomePage.searchHero');
   const prompt = t('tryPrompt', { prompt: props.prompt });

   return (
      <div className="relative z-[1] px-4 sm:px-0">
         <div className="text-center">
            {t.rich('title', {
               h1: chunks => (
                  <h1 className="m-0 text-white text-3xl md:text-5xl font-semibold text-pretty leading-tight">
                     {chunks}
                  </h1>
               ),
               h2: chunks => (
                  <h2 className="m-0 text-white text-lg md:text-xl font-semibold">{chunks}</h2>
               ),
            })}
         </div>

         <div className="mt-7 mb-2">
            <InstantSearch
               searchClient={searchClient}
               apiKey={PUBLIC_KEY}
               indices={indices}
               isProUser={isProUser()}
               placeholder={prompt}
               currency={App.userPreferredStoreCurrency}
               localeCode={App.userPreferredStoreLocale}
               storeCode={App.userPreferredStoreCode}
               inputProps={{
                  className: 'bg-white rounded-full min-h-14',
               }}
               popoverProps={{
                  side: 'bottom',
                  avoidCollisions: false,
               }}
            />
         </div>

         <div className="grid justify-center gap-2 text-sm">
            <p className="text-center font-medium text-white">{t('or')}</p>
            <button
               className="flex items-center gap-1.5 rounded-md !border-1 border-white/40 !bg-white/15 px-4 py-1.5 text-white hover:bg-white/20"
               onClick={() => {
                  trackAnalyticsCustomEvent({
                     eventCategory: 'Home Page',
                     eventAction: 'Home Page - CTA - Find Your Device',
                  });
                  void deviceNavigator();
               }}
            >
               <FaIcon name="list" />
               {t('ctaButton')}
            </button>
         </div>
      </div>
   );
}
